/* Progressive enhancement: retain every original node, including intro and attributed headings. */
(() => {
  function enhance(root) {
    root.querySelectorAll('[data-kz-faq]:not([data-kz-faq-ready])').forEach(container => {
      const nodes = Array.from(container.childNodes);
      if (!nodes.some(node => node.nodeType === 1 && node.tagName === 'H2')) return;
      const fragment = document.createDocumentFragment();
      let answer;
      nodes.forEach(node => {
        if (node.nodeType === 1 && node.tagName === 'H2') {
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          if (node.id) details.id = node.id;
          while (node.firstChild) summary.append(node.firstChild);
          const icon = document.createElement('span');
          icon.setAttribute('aria-hidden','true'); icon.textContent = '+';
          summary.append(icon);
          answer = document.createElement('div'); answer.className = 'rte';
          details.append(summary,answer); fragment.append(details);
        } else (answer || fragment).append(node);
      });
      container.replaceChildren(fragment);
      container.dataset.kzFaqReady = 'true';
    });
  }
  enhance(document);
  document.addEventListener('shopify:section:load',event => enhance(event.target));
})();
